export let Action = /*#__PURE__*/function (Action) {
  Action["Click"] = "Click";
  Action["View"] = "View";
  return Action;
}({});
export let Feature = /*#__PURE__*/function (Feature) {
  Feature["BudgetingFolderCreation"] = "Budgeting Folder Creation";
  return Feature;
}({});
export let Page = /*#__PURE__*/function (Page) {
  Page["BankingLauncher"] = "Banking Launcher";
  Page["SavingsOverview"] = "Savings Overview";
  return Page;
}({});
export let Target = /*#__PURE__*/function (Target) {
  Target["RecommendedCategory"] = "Recommended Category";
  Target["CustomFolder"] = "Create Custom Folder";
  return Target;
}({});
export let FolderName = /*#__PURE__*/function (FolderName) {
  FolderName["Taxes"] = "Taxes";
  FolderName["RainyDay"] = "Rainy_Day";
  FolderName["Rent"] = "Rent";
  FolderName["Payroll"] = "Payroll";
  FolderName["Custom"] = "Custom";
  FolderName["Expense"] = "Expense";
  FolderName["Retirement"] = "Retirement";
  FolderName["Profit"] = "Profit";
  FolderName["VehicleGas"] = "Vehicle_Gas";
  FolderName["Giving"] = "Giving";
  FolderName["Education"] = "Education";
  return FolderName;
}({});
const getEventName = (action, feature) => `${action} ${feature}`;
export function getEvent(action, args) {
  const feature = Feature.BudgetingFolderCreation;
  return {
    name: getEventName(action, feature),
    properties: {
      feature,
      applet: 'Banking',
      ...args
    }
  };
}